const AGE_GATE_COOKIE_NAME = 'ageGate';

export { AGE_GATE_COOKIE_NAME };
